'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toString2 = require('lodash/toString');

var _toString3 = _interopRequireDefault(_toString2);

exports.default = combineActions;

var _config = require('./config');

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function combineActions() {
  for (var _len = arguments.length, types = Array(_len), _key = 0; _key < _len; _key++) {
    types[_key] = arguments[_key];
  }

  return types.map(_toString3.default).join(_config2.default.separator);
}


//////////////////
// WEBPACK FOOTER
// ./~/berkeleys-redux-utils/lib/combine-actions.js
// module id = 566
// module chunks = 168707334958949